import React from 'react'
import './pageWrapper.scss'

export default function PageWrapper({children}) {
  return (
    <div id='pageWrapper'><div className='child'>{children}</div></div>
  )
}
